"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SocialMediaModule = void 0;
const base_1 = require("./base");
class SocialMediaModule extends base_1.SurveyModule {
    constructor({ color, facebook, instagram, snapchat, tiktok, twitter, ...rest }) {
        super(rest);
        this._type = "socialmedia";
        this.color = color;
        this.facebook = facebook;
        this.instagram = instagram;
        this.snapchat = snapchat;
        this.tiktok = tiktok;
        this.twitter = twitter;
    }
    validate() {
        return true;
    }
    toBuilderConfig() {
        return { ...this };
    }
    toSurveyConfig() {
        return { ...this };
    }
    editProps() {
        return undefined;
    }
}
exports.SocialMediaModule = SocialMediaModule;
//# sourceMappingURL=SocialMedia.js.map